import moment from 'moment';

import { DISPLAY_DATE_FORMAT } from '@/consts';

import {
  SET_ORDER,
  SET_ASSET,
  SET_CLIENT,
  SET_CONTRACT,
  SET_PRODUCT,
  SET_PROMOTION,
  RESET,
} from './types';

export const INIT_STATE = {
  order: {
    id: null,
    requiredAmount: null,
    proposedAmount: null,
    assetType: null,
    source: null,
    asset: null,
    client: null,
    firstName: '',
    phone: null,
  },
  asset: {
    id: null,
    description: null,
    meta: {},
  },
  client: {
    new: true,
    id: null,
    mifosId: 'XXXX',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    nationalId: '',
    address: '',
    district: '',
    city: '',
    gender: '',
    primaryPhone: '',
    alternativePhone: '',
  },
  contract: {
    id: null,
    approvedAmount: '',
    newApprovedAmount: '',
    maturesDate: moment().format(DISPLAY_DATE_FORMAT),
    dueDate: null,
    product: null,
    specialInterestValue: null,
    interestAmount: null,
    interestDiscountAmount: null,
    principalAmount: null,
    validator: null,
  },
  promotion: {
    id: null,
    promotionName: null,
    description: null,
    interestDiscount: null,
    maxDiscount: null,
    minDiscount: null,
    minPayout: null,
  },
  products: {},
};

const mutations = {
  [SET_ORDER](state, order) {
    state.order = {
      ...state.order,
      ...order
    };
  },
  [SET_ASSET](state, asset) {
    const meta = {
      ...state.asset.meta,
      ...asset.meta,
    };
    state.asset = {
      ...state.asset,
      ...asset,
      meta,
    };
  },
  [SET_CLIENT](state, client) {
    state.client = {
      ...state.client,
      ...client
    };
  },
  [SET_CONTRACT](state, contract) {
    state.contract = {
      ...state.contract,
      ...contract
    };
  },
  [SET_PRODUCT](state, products) {
    state.products = products;
  },
  [SET_PROMOTION](state, promotion) {
    state.promotion = {
      ...state.promotion,
      ...promotion,
    };
  },
  [RESET](state) {
    Object.keys(INIT_STATE).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(INIT_STATE, key)) {
        state[key] = INIT_STATE[key];
      }
    });
  },
};

export default mutations;
